// import React, { useState, useEffect } from "react";
// import { Card, Table, Input, Button, Space, Tooltip } from "antd";
// import { EyeOutlined, EditOutlined } from "@ant-design/icons";
// import Modal from "../../components/Modal";
// import { useGet } from "../../hooks/useApi";
// import { useDebounce } from "../../hooks/useDebounce";
// import { API_ENDPOINTS, API_BASE_URL } from "../../config/api";
// import Toast from "../../utils/toast";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";

// const ContentManager = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedContent, setSelectedContent] = useState(null);
//   const [isViewMode, setIsViewMode] = useState(false);

//   // State for form data - ONLY CONTENT IS EDITABLE
//   const [formData, setFormData] = useState({
//     content: "",
//   });

//   // Search and pagination states
//   const [searchTerm, setSearchTerm] = useState("");
//   const debouncedSearchTerm = useDebounce(searchTerm, 500);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalCount, setTotalCount] = useState(0);
//   const [contentList, setContentList] = useState([]);

//   const [isSaving, setIsSaving] = useState(false);

//   const buildApiUrl = () => {
//     let url = `${API_ENDPOINTS.CONTENT_GET_ALL}?page=${currentPage}&page_size=${pageSize}`;

//     // Add search parameter
//     if (debouncedSearchTerm) {
//       url += `&search=${encodeURIComponent(debouncedSearchTerm)}`;
//     }

//     return url;
//   };

//   // Use GET for listing content with pagination and search
//   const apiUrl = buildApiUrl();
//   const { loading: loadingContent, execute: fetchContent } = useGet(
//     apiUrl,
//     false,
//   );

//   // Load data function
//   const loadData = async () => {
//     try {
//       const response = await fetchContent();
//       if (response) {
//         setContentList(response.data || []);
//         setTotalPages(response.pagination?.total_pages || 1);
//         setTotalCount(response.pagination?.total_count || 0);
//       }
//     } catch (error) {
//       console.error("Error loading data:", error);
//       Toast.error(error.message || t("common.error"));
//     }
//   };

//   // Initial data fetch
//   useEffect(() => {
//     loadData();
//   }, [currentPage, pageSize]);

//   // Handle search - triggers when debounced value changes
//   useEffect(() => {
//     setCurrentPage(1); // Reset to first page on search
//     loadData();
//   }, [debouncedSearchTerm]);

//   const handleTextareaChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Reset form data
//   const resetForm = () => {
//     setFormData({
//       content: "",
//     });
//     setSelectedContent(null);
//     setIsViewMode(false);
//   };

//   // Function to get token
//   const getToken = () => {
//     return (
//       localStorage.getItem("adminToken") ||
//       localStorage.getItem("access_token") ||
//       localStorage.getItem("token") ||
//       sessionStorage.getItem("adminToken") ||
//       sessionStorage.getItem("access_token")
//     );
//   };

//   // Custom PUT function for update
//   const customPut = async (url, data) => {
//     const token = getToken();
//     if (!token) {
//       Toast.error(t("common.error"));
//       throw new Error("Authentication token not found");
//     }

//     try {
//       const response = await fetch(`${API_BASE_URL}${url}`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(data),
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(result.message || t("contentManager.failedUpdate"));
//       }

//       return result;
//     } catch (error) {
//       console.error("PUT request failed:", error);
//       throw error;
//     }
//   };

//   // Custom GET by ID function
//   const customGetById = async (url) => {
//     const token = getToken();
//     if (!token) {
//       Toast.error(t("common.error"));
//       throw new Error("Authentication token not found");
//     }

//     try {
//       const response = await fetch(`${API_BASE_URL}${url}`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(
//           result.message || t("contentManager.failedFetchDetails"),
//         );
//       }

//       return result;
//     } catch (error) {
//       console.error("GET by ID request failed:", error);
//       throw error;
//     }
//   };

//   // Navigate to view page
//   const openViewPage = (id) => {
//     navigate(`/content/details/${id}`);
//   };

//   // Open modal for edit
//   const openEditModal = async (content) => {
//     try {
//       setSelectedContent(content);

//       const endpoint = `${API_ENDPOINTS.CONTENT_GET_BY_ID}/${content.id}`;
//       const response = await customGetById(endpoint);

//       if (response?.status === true && response.data) {
//         setSelectedContent(response.data);
//         setFormData({
//           content: response.data.content || "",
//         });
//         setIsViewMode(false);
//         setIsModalOpen(true);
//       } else {
//         Toast.error(t("contentManager.failedFetchDetails"));
//       }
//     } catch (error) {
//       console.error("Error fetching content details:", error);
//       Toast.error(error.message || t("contentManager.failedFetchDetails"));
//     }
//   };

//   // Handle update content
//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     if (!selectedContent?.id) {
//       Toast.error(t("contentManager.idNotFound"));
//       return;
//     }

//     // Validation
//     if (!formData.content.trim()) {
//       Toast.error(t("contentManager.contentRequired"));
//       return;
//     }

//     setIsSaving(true);
//     try {
//       const endpoint = `${API_ENDPOINTS.CONTENT_UPDATE}/${selectedContent.id}`;
//       const response = await customPut(endpoint, formData);

//       if (response?.status === true) {
//         Toast.success(response?.message || t("contentManager.updatedSuccess"));
//         await loadData();
//         setIsModalOpen(false);
//         resetForm();
//       } else {
//         Toast.error(response?.message || t("contentManager.failedUpdate"));
//       }
//     } catch (error) {
//       console.error("Error updating content:", error);
//       Toast.error(error.message || t("contentManager.failedUpdate"));
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // Format date for display
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     return date.toLocaleDateString(i18n.language === "nl" ? "nl-NL" : "en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   // Format page_type to readable title
//   const formatPageType = (pageType) => {
//     if (!pageType) return "N/A";

//     // Convert snake_case to Title Case with spaces
//     return pageType
//       .split("_")
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//       .join(" ");
//   };

//   const columns = [
//     {
//       title: t("contentManager.pageType"),
//       dataIndex: "page_type",
//       key: "page_type",
//       render: (type) => <strong>{formatPageType(type)}</strong>,
//     },
//     {
//       title: t("common.createdAt"),
//       dataIndex: "created_at",
//       key: "created_at",
//       render: (date) => formatDate(date),
//     },
//     {
//       title: t("common.lastUpdated"),
//       key: "updated_at",
//       render: (_, record) => formatDate(record.updated_at || record.created_at),
//     },
//     {
//       title: t("common.actions"),
//       key: "actions",
//       render: (_, record) => (
//         <Space>
//           <Tooltip title={t("common.view")}>
//             <Button
//               className="btn-view"
//               type="primary"
//               size="small"
//               icon={<EyeOutlined />}
//               onClick={() => openViewPage(record.id)}
//             />
//           </Tooltip>
//           <Tooltip title={t("common.edit")}>
//             <Button
//               className="btn-edit"
//               type="primary"
//               size="small"
//               style={{ background: "#52c41a", borderColor: "#52c41a" }}
//               icon={<EditOutlined />}
//               onClick={() => openEditModal(record)}
//             />
//           </Tooltip>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <>
//       <Card title={t("contentManager.title")}>
//         <Input
//           placeholder={t("contentManager.searchPlaceholder")}
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           allowClear
//           style={{ maxWidth: 400, marginBottom: 16 }}
//           disabled={loadingContent}
//         />

//         <div className="table-responsive">
//           <Table
//             dataSource={contentList}
//             columns={columns}
//             rowKey="id"
//             loading={loadingContent}
//             locale={{
//               emptyText: searchTerm
//                 ? t("contentManager.noMatchingContent")
//                 : t("contentManager.noContentFound"),
//             }}
//             pagination={{
//               current: currentPage,
//               pageSize,
//               total: totalCount,
//               showSizeChanger: true,
//               pageSizeOptions: ["5", "10", "20", "50", "100"],
//               showTotal: (total) =>
//                 `${t("common.showing")} ${(currentPage - 1) * pageSize + 1} ${t("common.to")} ${Math.min(currentPage * pageSize, total)} ${t("common.of")} ${total} ${t("common.contentPages")}`,
//               onChange: (page, size) => {
//                 setCurrentPage(page);
//                 setPageSize(size || 10);
//               },
//             }}
//           />
//         </div>
//       </Card>

//       {/* Edit Modal */}
//       {isModalOpen && !isViewMode && selectedContent && (
//         <Modal
//           isOpen={isModalOpen}
//           onClose={() => {
//             setIsModalOpen(false);
//             resetForm();
//           }}
//           title={`${t("contentManager.editContent")} ${formatPageType(selectedContent.page_type)}`}
//           onConfirm={handleUpdate}
//           confirmText={
//             isSaving
//               ? t("contentManager.saving")
//               : t("contentManager.saveChanges")
//           }
//           showConfirm={true}
//           size="large"
//           confirmDisabled={isSaving}
//         >
//           <div className="modal-content">
//             <div className="content-header">
//               <div className="content-info">
//                 <h3 className="content-title">
//                   {formatPageType(selectedContent.page_type)}
//                 </h3>
//                 <div className="content-meta">
//                   <span className="meta-item">
//                     <strong>{t("contentManager.created")}</strong>{" "}
//                     {formatDate(selectedContent.created_at)}
//                   </span>
//                   <span className="meta-item">
//                     <strong>{t("common.lastUpdated")}:</strong>{" "}
//                     {formatDate(
//                       selectedContent.updated_at || selectedContent.created_at,
//                     )}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className="content-form">
//               <div className="form-group">
//                 <label htmlFor="content">
//                   {t("contentManager.contentLabel")}{" "}
//                   <span className="required">*</span>
//                 </label>
//                 <textarea
//                   id="content"
//                   name="content"
//                   value={formData.content}
//                   onChange={handleTextareaChange}
//                   placeholder={t("contentManager.contentPlaceholder")}
//                   rows="15"
//                   style={{
//                     width: "100%",
//                     padding: "15px",
//                     fontFamily: "monospace",
//                     fontSize: "14px",
//                     lineHeight: "1.5",
//                     border: "1px solid #ddd",
//                     borderRadius: "4px",
//                     resize: "vertical",
//                   }}
//                 />
//                 <div className="form-help">{t("contentManager.htmlHelp")}</div>
//               </div>

//               <div className="html-preview">
//                 <h4>{t("contentManager.preview")}:</h4>
//                 <div
//                   className="preview-content"
//                   style={{
//                     border: "1px solid #eee",
//                     padding: "15px",
//                     borderRadius: "4px",
//                     maxHeight: "200px",
//                     overflowY: "auto",
//                     backgroundColor: "#f9f9f9",
//                   }}
//                   dangerouslySetInnerHTML={{
//                     __html:
//                       formData.content ||
//                       `<p><em>${t("contentManager.noContentToPreview")}</em></p>`,
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//         </Modal>
//       )}
//     </>
//   );
// };

// export default ContentManager;

import React, { useState, useEffect } from "react";
import { Card, Table, Input, Button, Space, Tooltip } from "antd";
import { EyeOutlined, EditOutlined } from "@ant-design/icons";
import Modal from "../../components/Modal";
import { useGet, useDynamicApi } from "../../hooks/useApi";
import { useDebounce } from "../../hooks/useDebounce";
import { API_ENDPOINTS } from "../../config/api";
import Toast from "../../utils/toast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ContentManager = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedContent, setSelectedContent] = useState(null);
  const [isViewMode, setIsViewMode] = useState(false);

  // Form state – only content is editable
  const [formData, setFormData] = useState({
    content: "",
  });

  // Search and pagination states
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [contentList, setContentList] = useState([]);

  // Loading states
  const [isSaving, setIsSaving] = useState(false);

  // Build API URL for list with pagination and search
  const buildApiUrl = () => {
    let url = `${API_ENDPOINTS.CONTENT_GET_ALL}?page=${currentPage}&page_size=${pageSize}`;
    if (debouncedSearchTerm) {
      url += `&search=${encodeURIComponent(debouncedSearchTerm)}`;
    }
    return url;
  };

  const apiUrl = buildApiUrl();

  // Hooks for API calls
  const { loading: loadingList, execute: fetchContent } = useGet(apiUrl, false);
  const { execute: getContentById, loading: loadingDetail } =
    useDynamicApi("GET");
  const { execute: updateContent, loading: updating } = useDynamicApi("PUT");

  // Combined loading state
  const loading = loadingList || loadingDetail || updating || isSaving;

  // Load data function
  const loadData = async () => {
    try {
      const response = await fetchContent();
      if (response) {
        setContentList(response.data || []);
        setTotalCount(response.pagination?.total_count || 0);
      }
    } catch (error) {
      console.error("Error loading content:", error);
      Toast.error(error.message || t("common.error"));
    }
  };

  // Initial load & pagination change
  useEffect(() => {
    loadData();
  }, [currentPage, pageSize]);

  // Reload when search changes (reset to page 1)
  useEffect(() => {
    setCurrentPage(1);
    loadData();
  }, [debouncedSearchTerm]);

  // Reset form and modal state
  const resetForm = () => {
    setFormData({ content: "" });
    setSelectedContent(null);
    setIsViewMode(false);
  };

  // Handle textarea change
  const handleTextareaChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Open edit modal
  const openEditModal = async (content) => {
    try {
      const endpoint = `${API_ENDPOINTS.CONTENT_GET_BY_ID}/${content.id}`;
      const response = await getContentById(endpoint);

      if (response?.status === true && response.data) {
        setSelectedContent(response.data);
        setFormData({ content: response.data.content || "" });
        setIsViewMode(false);
        setIsModalOpen(true);
      } else {
        Toast.error(t("contentManager.failedFetchDetails"));
      }
    } catch (error) {
      console.error("Error fetching content details:", error);
      Toast.error(error.message || t("contentManager.failedFetchDetails"));
    }
  };

  // Handle update
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!selectedContent?.id) {
      Toast.error(t("contentManager.idNotFound"));
      return;
    }

    if (!formData.content.trim()) {
      Toast.error(t("contentManager.contentRequired"));
      return;
    }

    setIsSaving(true);
    try {
      const endpoint = `${API_ENDPOINTS.CONTENT_UPDATE}/${selectedContent.id}`;
      const response = await updateContent(endpoint, formData);

      if (response?.status === true) {
        Toast.success(response?.message || t("contentManager.updatedSuccess"));
        await loadData();
        setIsModalOpen(false);
        resetForm();
      } else {
        Toast.error(response?.message || t("contentManager.failedUpdate"));
      }
    } catch (error) {
      console.error("Error updating content:", error);
      Toast.error(error.message || t("contentManager.failedUpdate"));
    } finally {
      setIsSaving(false);
    }
  };

  // Navigate to view page
  const openViewPage = (id) => {
    navigate(`/content/details/${id}`);
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString(i18n.language === "nl" ? "nl-NL" : "en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Format page_type to readable title
  const formatPageType = (pageType) => {
    if (!pageType) return "N/A";
    return pageType
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const columns = [
    {
      title: t("contentManager.pageType"),
      dataIndex: "page_type",
      key: "page_type",
      render: (type) => <strong>{formatPageType(type)}</strong>,
    },
    {
      title: t("common.createdAt"),
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => formatDate(date),
    },
    {
      title: t("common.lastUpdated"),
      key: "updated_at",
      render: (_, record) => formatDate(record.updated_at || record.created_at),
    },
    {
      title: t("common.actions"),
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title={t("common.view")}>
            <Button
              className="btn-view"
              type="primary"
              size="small"
              icon={<EyeOutlined />}
              onClick={() => openViewPage(record.id)}
            />
          </Tooltip>
          <Tooltip title={t("common.edit")}>
            <Button
              className="btn-edit"
              type="primary"
              size="small"
              style={{ background: "#52c41a", borderColor: "#52c41a" }}
              icon={<EditOutlined />}
              onClick={() => openEditModal(record)}
              disabled={loading}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Card title={t("contentManager.title")}>
        <Input
          placeholder={t("contentManager.searchPlaceholder")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          allowClear
          style={{ maxWidth: 400, marginBottom: 16 }}
          disabled={loadingList}
        />

        <div className="table-responsive">
          <Table
            dataSource={contentList}
            columns={columns}
            rowKey="id"
            loading={loadingList}
            locale={{
              emptyText: searchTerm
                ? t("contentManager.noMatchingContent")
                : t("contentManager.noContentFound"),
            }}
            pagination={{
              current: currentPage,
              pageSize,
              total: totalCount,
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "50", "100"],
              showTotal: (total) =>
                `${t("common.showing")} ${(currentPage - 1) * pageSize + 1} ${t("common.to")} ${Math.min(currentPage * pageSize, total)} ${t("common.of")} ${total} ${t("common.contentPages")}`,
              onChange: (page, size) => {
                setCurrentPage(page);
                setPageSize(size || 10);
              },
            }}
          />
        </div>
      </Card>

      {/* Edit Modal */}
      {isModalOpen && !isViewMode && selectedContent && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            resetForm();
          }}
          title={`${t("contentManager.editContent")} ${formatPageType(selectedContent.page_type)}`}
          onConfirm={handleUpdate}
          confirmText={
            isSaving || updating
              ? t("contentManager.saving")
              : t("contentManager.saveChanges")
          }
          showConfirm={true}
          size="large"
          confirmDisabled={isSaving || updating}
        >
          <div className="modal-content">
            <div className="content-header">
              <div className="content-info">
                <h3 className="content-title">
                  {formatPageType(selectedContent.page_type)}
                </h3>
                <div className="content-meta">
                  <span className="meta-item">
                    <strong>{t("contentManager.created")}</strong>{" "}
                    {formatDate(selectedContent.created_at)}
                  </span>
                  <span className="meta-item">
                    <strong>{t("common.lastUpdated")}:</strong>{" "}
                    {formatDate(
                      selectedContent.updated_at || selectedContent.created_at,
                    )}
                  </span>
                </div>
              </div>
            </div>

            <div className="content-form">
              <div className="form-group">
                <label htmlFor="content">
                  {t("contentManager.contentLabel")}{" "}
                  <span className="required">*</span>
                </label>
                <textarea
                  id="content"
                  name="content"
                  value={formData.content}
                  onChange={handleTextareaChange}
                  placeholder={t("contentManager.contentPlaceholder")}
                  rows="15"
                  style={{
                    width: "100%",
                    padding: "15px",
                    fontFamily: "monospace",
                    fontSize: "14px",
                    lineHeight: "1.5",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    resize: "vertical",
                  }}
                  disabled={isSaving || updating}
                />
                <div className="form-help">{t("contentManager.htmlHelp")}</div>
              </div>

              <div className="html-preview">
                <h4>{t("contentManager.preview")}:</h4>
                <div
                  className="preview-content"
                  style={{
                    border: "1px solid #eee",
                    padding: "15px",
                    borderRadius: "4px",
                    maxHeight: "200px",
                    overflowY: "auto",
                    backgroundColor: "#f9f9f9",
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      formData.content ||
                      `<p><em>${t("contentManager.noContentToPreview")}</em></p>`,
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ContentManager;
